// extracted by mini-css-extract-plugin
module.exports = {"standardTabButton":"standardTabButton__28_LB","standardTabPanel":"standardTabPanel__2pKLK","standardTabSlider":"standardTabSlider__3-FWq"};